import { JSX, ReactNode } from 'react';
import { Box, Button, ButtonGroup } from '@chakra-ui/react';
import { Modal } from 'shared-components';

interface RequestTasksModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
  title: string;
  description: ReactNode;
}

export const RequestTasksModal = ({
  isOpen,
  onClose,
  onConfirm,
  isLoading = false,
  title,
  description,
}: RequestTasksModalProps): JSX.Element => {
  return (
    <Modal
      show={isOpen}
      onClose={onClose}
      title={title}
      footer={
        <ButtonGroup spacing={3} size={'lg'}>
          <Button onClick={onClose} isDisabled={isLoading}>
            Cancel
          </Button>
          <Button variant="solid" onClick={onConfirm} isLoading={isLoading}>
            Request tasks
          </Button>
        </ButtonGroup>
      }
    >
      <Box>{description}</Box>
    </Modal>
  );
};
